export default __webpack_public_path__ + "static/media/attractions5.d8922b07.png";